import styled from '@emotion/styled'

export const CenteredLabel = styled.label`
  display: flex;
  flex: 1;
  height: 100%;
  text-align: center;
  align-items: center;
  justify-content: center;
`
